module.exports = __webpack_public_path__ + "media/zips/TP-Icon-Logo-f44cee1b2c4ca8ff71d1907496066390.zip";